import * as THREE from 'three'

import ProjectBoardMaterial from '../../Materials/ProjectBoard.js'
import TweenLite from 'gsap/TweenLite'
import { Power4 } from 'gsap/EasePack'

export default class Project
{
    constructor(_options)
    {
        this.time = _options.time
        this.resources = _options.resources
        this.objects = _options.objects
        this.areas = _options.areas
        this.name = _options.name
        this.geometries = _options.geometries
        this.meshes = _options.meshes
        this.debug = _options.debug
        this.name = _options.name
        this.x = _options.x
        this.y = _options.y
        this.imageSources = _options.imageSources
        this.floorTexture = _options.floorTexture
        this.link = _options.link
        this.distinctions = _options.distinctions

        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.setBoards()
        this.setFloor()
        this.setVideo()
    }

    setVideo(){

    }

    setBoards()
    {
        this.boards = {}
        this.boards.items = []
        this.boards.xStart = - 5
        this.boards.xInter = 5
        this.boards.y = 5
        this.boards.color = '#8e7161'
        this.boards.threeColor = new THREE.Color(this.boards.color)

        if(this.debug)
        {
            this.debug.addColor(this.boards, 'color').name('boardColor').onChange(() =>
            {
                this.boards.threeColor.set(this.boards.color)
            })
        }

        let i = 0

        for(const _imageSource of this.imageSources)
        {
            const board = {}
            board.x = this.x + this.boards.xStart + i * this.boards.xInter
            board.y = this.y + this.boards.y
            this.objects.add({
                base: this.resources.items.projectsBoardStructure.scene,
                collision: this.resources.items.projectsBoardCollision.scene,
                floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture,
                offset: new THREE.Vector3(board.x, board.y, 0),
                rotation: new THREE.Euler(0, 0, 0),
                duplicated: true,
                mass: 0
            })
            const image = new Image()
            image.addEventListener('load', () =>
            {
                board.texture = new THREE.Texture(image)
                board.texture.needsUpdate = true
                board.texture.magFilter = THREE.NearestFilter
                board.texture.minFilter = THREE.LinearFilter

                board.planeMesh.material.uniforms.uTexture.value = board.texture

                TweenLite.to(board.planeMesh.material.uniforms.uTextureAlpha, 1, { value: 1, ease: Power4.inOut })
            })

            image.src = _imageSource

            board.planeMesh = this.meshes.boardPlane.clone()
            board.planeMesh.position.x = board.x
            board.planeMesh.position.y = board.y
            board.planeMesh.matrixAutoUpdate = false
            board.planeMesh.updateMatrix()
            board.planeMesh.material = new ProjectBoardMaterial()
            board.planeMesh.material.uniforms.uColor.value = this.boards.threeColor
            board.planeMesh.material.uniforms.uTextureAlpha.value = 0
            this.container.add(board.planeMesh)
            // console.log(this.objects)
            // console.log(board)
            this.boards.items.push(board)

            i++
        }
    }

    setFloor()
    {
        this.floor = {}

        this.floor.x = 0
        this.floor.y = - 2

        this.floor.container = new THREE.Object3D()
        this.floor.container.position.x = this.x + this.floor.x
        this.floor.container.position.y = this.y + this.floor.y
        this.floor.container.matrixAutoUpdate = false
        this.floor.container.updateMatrix()
        this.container.add(this.floor.container)

        this.floor.texture = this.floorTexture
        this.floor.texture.magFilter = THREE.NearestFilter
        this.floor.texture.minFilter = THREE.LinearFilter
        this.floor.geometry = this.geometries.floor
        this.floor.material =  new THREE.MeshBasicMaterial({ transparent: true, depthWrite: false, alphaMap: this.floor.texture })
        this.floor.mesh = new THREE.Mesh(this.floor.geometry, this.floor.material)
        this.floor.mesh.matrixAutoUpdate = false
        this.floor.container.add(this.floor.mesh)

        // 项目技术栈
        if(this.distinctions)
        {
            for(const _distinction of this.distinctions)
            {
                let base = null
                let collision = null
                let shadowSizeX = null
                let shadowSizeY = null

                switch(_distinction.type)
                {
                    case 'Activiti':
                        base = this.resources.items.projectsDistinctionsActivitiBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'C':
                        base = this.resources.items.projectsDistinctionsCBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionLBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'ChatGPT':
                        base = this.resources.items.projectsDistinctionsChatGPTBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Dubbo':
                        base = this.resources.items.projectsDistinctionsDubboBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Docker':
                        base = this.resources.items.projectsDistinctionsDockerBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Elasticsearch':
                        base = this.resources.items.projectsDistinctionsElasticsearchBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Eureka':
                        base = this.resources.items.projectsDistinctionsEurekaBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Feign':
                        base = this.resources.items.projectsDistinctionsFeignBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Golang':
                        base = this.resources.items.projectsDistinctionsGolangBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Hadoop':
                        base = this.resources.items.projectsDistinctionsHadoopBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Hystrix':
                        base = this.resources.items.projectsDistinctionsHystrixBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Java':
                        base = this.resources.items.projectsDistinctionsJavaBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'JMeter':
                        base = this.resources.items.projectsDistinctionsJMeterBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'JQuery':
                        base = this.resources.items.projectsDistinctionsJQueryBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Kafka':
                        base = this.resources.items.projectsDistinctionsKafkaBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Lucene':
                        base = this.resources.items.projectsDistinctionsLuceneBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'MongoDB':
                        base = this.resources.items.projectsDistinctionsMongoDBBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionLBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Mybatis':
                        base = this.resources.items.projectsDistinctionsMybatisBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Mysql':
                        base = this.resources.items.projectsDistinctionsMysqlBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Nacos':
                        base = this.resources.items.projectsDistinctionsNacosBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Node':
                        base = this.resources.items.projectsDistinctionsNodeBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Oracle':
                        base = this.resources.items.projectsDistinctionsOracleBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Python':
                        base = this.resources.items.projectsDistinctionsPythonBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Quartz':
                        base = this.resources.items.projectsDistinctionsQuartzBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Redis':
                        base = this.resources.items.projectsDistinctionsRedisBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'React':
                        base = this.resources.items.projectsDistinctionsReactBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Ribbon':
                        base = this.resources.items.projectsDistinctionsRibbonBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'RocketMQ':
                        base = this.resources.items.projectsDistinctionsRocketMQBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionLBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Spring':
                        base = this.resources.items.projectsDistinctionsSpringBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Three':
                        base = this.resources.items.projectsDistinctionsThreeBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'VUE':
                        base = this.resources.items.projectsDistinctionsVUEBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionSBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                    case 'Zookeeper':
                        base = this.resources.items.projectsDistinctionsZookeeperBase.scene
                        collision = this.resources.items.projectsDistinctionsCollisionLBase.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break
                }

                this.objects.add({
                    base: base,
                    collision: collision,
                    offset: new THREE.Vector3(this.x + this.floor.x + _distinction.x, this.y + this.floor.y + _distinction.y, 0),
                    rotation: new THREE.Euler(0, 0, 0),
                    duplicated: true,
                    shadow: { sizeX: shadowSizeX, sizeY: shadowSizeY, offsetZ: - 0.1, alpha: 0.5 },
                    mass: 1.5,
                    soundName: 'woodHit'
                })
            }
        }

        // 链接区域
        if(this.link != undefined){
            this.floor.area = this.areas.add({
                position: new THREE.Vector2(this.x + this.link.x, this.y + this.floor.y + this.link.y),
                halfExtents: new THREE.Vector2(this.link.halfExtents.x, this.link.halfExtents.y)
            })
            this.floor.area.on('interact', () =>
            {
                window.open(this.link.href, '_blank')
            })
            this.floor.areaLabel = this.meshes.areaLabel.clone()
            this.floor.areaLabel.position.x = this.link.x
            this.floor.areaLabel.position.y = this.link.y
            this.floor.areaLabel.position.z = 0.001
            this.floor.areaLabel.matrixAutoUpdate = false
            this.floor.areaLabel.updateMatrix()
            this.floor.container.add(this.floor.areaLabel)
        }

    }
}
